import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import '../styles/button.scss'

function Button({ component, className, isSubscription, isSubscriptionInPromo, isSettings, ...props }) {
  return React.createElement(component, {
    ...props,
    className: classnames(
      'account-button',
      { 'account-button--subscription': isSubscription },
      { 'account-button--subscription account-button--subscription-in-promo': isSubscriptionInPromo },
      { 'account-button--settings': isSettings },
      className
    )
  })
}

Button.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
}

Button.defaultProps = {
  component: 'button'
}

export default React.memo(Button)
